// extracted by mini-css-extract-plugin
export default {"cell":"oQb4KQ","content":"_6hUDE","hasEvents":"XRvv5U","weekend":"pQeh0b","today":"uVFY4V","weekendToday":"NBvVOc","dayNumber":"n66ATC","otherMonth":"AXL_uf","skeletonLine":"ZWQGoK"};